{
  "actions": "Akcie"
}
